import { Navigate } from 'react-router-dom';

/**
 * /programs/year-7-8-foundations has been merged into the main Foundations
 * programme (now covering Prep/Kindergarten - Year 8). This component
 * permanently redirects the old URL to preserve inbound links from
 * organic search, bookmarks, marketing emails, and external sites.
 */
const Year78Foundations = () => {
  return <Navigate to="/programs/foundations" replace />;
};

export default Year78Foundations;
